import { MdMenu } from 'react-icons/md';
import HomeNavBar from '../Components/HomeNavBar';
import { useState, useEffect, useRef } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Logo from '../Components/Images/reccur logo.svg'
import bg from '../Components/Images/bg2.png'
import scroll from '../Components/Images/scroll.png'
import newLogo from '../Components/Images/newLogo.png'
import countries from '../Components/Images/countries.png'
import hand from '../Components/Images/hand.png'
import us from '../Components/Images/us.png'
import ngn from '../Components/Images/ngn.png'
import brazil from '../Components/Images/brazil.png'
import sa from '../Components/Images/sa.png'
import greece from '../Components/Images/greece.png'
import china from '../Components/Images/china.png'
import france2 from '../Components/Images/france2.png'
import uk1 from '../Components/Images/uk1.png'
import mexico1 from '../Components/Images/mexico1.png'
import canada from '../Components/Images/cana.png'
import india1 from '../Components/Images/india1.png'
import ghana from '../Components/Images/ghana.png'
import frame from '../Components/Images/Frame 1.png'
// import nigeria from '../Components/Images/nigeria2.png'
// import uk from '../Components/Images/uk2.png'
import flag1 from '../Components/Images/Flag1.png'
import flag2 from '../Components/Images/Flag2.png'
import flag3 from '../Components/Images/Flag3.png'
import flag4 from '../Components/Images/Flag4.png'
import flag5 from '../Components/Images/Flag5.png'
import flag6 from '../Components/Images/Flag6.png'
import flag7 from '../Components/Images/Flag7.png'
import us2 from '../Components/Images/us2.png'
import ngn2 from '../Components/Images/ngn2.png'
import brazil2 from '../Components/Images/brazil2.png'
import sa2 from '../Components/Images/sa2.png'
import greece2 from '../Components/Images/greece2.png'
import china2 from '../Components/Images/china2.png'
import ghana2 from '../Components/Images/ghana2.png'
import mexico2 from '../Components/Images/mexico2.png'
import canada2 from '../Components/Images/canada2.png'
import uk2 from '../Components/Images/uk2.0.png'
import india2 from '../Components/Images/india2.png'
import france3 from '../Components/Images/france3.png'
import combine from '../Components/Images/combine.png'
import stars from '../Components/Images/stars.png'
import { RiArrowRightSLine } from 'react-icons/ri';
import { FaArrowRight } from "react-icons/fa6";
import FAQ2 from '../Components/FAQ2';
import Footer from '../Components/Footer';
import { useLocation } from 'react-router-dom';
import Marquee from "../Components/Marquee";

const HomeRoot2 = () => {

    const [openMenu, setOpenMenu] = useState(false)
    const location = useLocation()
    const rightSlider = useRef(null);
    const leftSlider = useRef(null);

    const messages = [
        'Cash out to ₦, ₵, KSh, ZAR, £, $ - or your crypto wallet',
        'Settles as fully-backed USDC - no bank holds',
        'Personal ACH routing & IBAN issued on sign-up'
    ];

    const settingsLeft = {
        infinite: true,
        speed: 700,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        arrows: false,
        dots: false,
        vertical: true,
        verticalSwiping: true,
    };

    const settingsRight = {
        infinite: true,
        speed: 700,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        arrows: false,
        dots: false,
        vertical: true,
        verticalSwiping: true,
    };

    useEffect(() => {
        let toggle = true; // start with right
        const interval = setInterval(() => {
            if (toggle) {
                // Move RIGHT
                if (rightSlider.current) {
                    rightSlider.current.slickNext();
                }
            } else {
                // Move LEFT
                if (leftSlider.current) {
                    leftSlider.current.slickNext();
                }
            }
            toggle = !toggle; // alternate
        }, 2500); // pause time between moves

        return () => clearInterval(interval);
    }, []);


    useEffect(() => {
        AOS.init({
            duration: 1200,
            easing: "ease-out-sine",
            offset: 200,
            once: true
        })
        AOS.refresh()
    }, [])

    return (
        <div className='3xl:text-2xl mk:text-lg sd:text-[17px] text-[14px]'>
            <div className='sd:m-10'>
                <div
                    className="relative w-full rounded-[20px] parent-container bg-[#E8E1F5] overflow-hidden"
                    style={{
                        backgroundImage: `url(${bg})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        backgroundColor: '#E8E1F5'
                    }}
                >
                    <div className='relative w-full top-0 rounded-[20px] z-50 text-black sd:px-12 px-2'>
                        <div className='relative'>
                            {/* Navbar */}
                            <div className='flex justify-between items-center px-2 sd:py-12 py-4 pb-16'>
                                <a href="/">
                                    <div className='flex gap-2 items-center'>
                                        <img src={Logo} className='mk:w-auto w-5' alt="" />
                                        <p className='font-medium'>reccur</p>
                                    </div>
                                </a>
                                <div className='lg:flex hidden gap-8 ml-24'>
                                    <a href="/use_cases">
                                        <p className={`${location.pathname === 'use_cases' && 'font-bold'}`}>Use cases</p>
                                    </a>
                                    <a href="/how_it_works">
                                        <p className={`${location.pathname === 'how_it_works' && 'font-bold'}`}>How it Works</p>
                                    </a>
                                    <a href="/about">
                                        <p className={`${location.pathname === 'about' && 'font-bold'}`}>About</p>
                                    </a>
                                </div>
                                <div className='lg:flex hidden'>
                                    <a href="/login">
                                        <button className='py-2 px-[14px]'>Log in</button>
                                    </a>
                                    <a href="/signup">
                                        <button className='bg-[#531CB3] font-light text-white py-2 px-[14px] rounded-[10px]'>
                                            Get started
                                        </button>
                                    </a>
                                </div>
                                <MdMenu onClick={() => setOpenMenu(!openMenu)} className='lg:hidden cursor-pointer sh:text-[30px] text-xl' />
                            </div>

                            {/* Content + Hand inside */}
                            <div className='flex lg:flex-row relative flex-col justify-between gap-6 w-full sd:mt-20 lg:items-start items-center'>
                                <div className='lg:w-1/2 flex flex-col lg:items-start items-center gap-6'>
                                    <img className='sd:size-32 size-24' src={newLogo} alt="" />
                                    <p className='font-semibold 3xl:text-5xl text-center lg:text-start text-4xl'>
                                        Your global money. <br /> In your name.
                                    </p>
                                    <p className='text-[#525154] lg:text-start text-center font-normal'>
                                        Open a real USD & EUR account - instantly, in your own name - get paid today,
                                        <br className='2xl:block hidden' /> hold the value in USDC, and move it anywhere
                                        from Lagos to London in minutes.
                                    </p>
                                    <a href="/signup">
                                        <button className='bg-[#531CB3] text-white flex gap-2 items-center justify-center sh:py-[14px] py-[9px] px-[24px] shadow-md shadow-[#531CB3] rounded-lg'>
                                            Get started
                                            <RiArrowRightSLine className='size-7' />
                                        </button>
                                    </a>
                                    <div className='flex items-center lg:ml-[-16px] sd:gap-0'>
                                        <img className='3xl:w-36 sd:w-28 w-[70px]' src={countries} alt="" />
                                        <p className='text-[#525154] font-normal'>Open a bank account in 30+ countries.</p>
                                    </div>
                                    <div className='lg:flex hidden flex-col mt-40 mb-12 gap-1'>
                                        <img className='w-[40px] ml-6' src={scroll} alt="" />
                                        <p className=''>Scroll down</p>
                                    </div>
                                </div>

                                {/* 👇 Hand image moved INSIDE here */}
                                <img
                                    data-aos='slide-up'
                                    data-aos-delay='200'
                                    data-aos-anchor=".parent-container"
                                    data-aos-anchor-placement="top-bottom"
                                    src={hand}
                                    className='lg:absolute bottom-0 lg:mt-0 mt-7 right-0 2xl:h-[840px] lg:mr-0 mr-[-90px] sd:h-[600px]'
                                    alt=""
                                />
                            </div>
                        </div>
                        <HomeNavBar openMenu={openMenu} setOpenMenu={setOpenMenu} />
                    </div>
                </div>
            </div>

            <Marquee speed={1.3}>
                <img className="lg:w-[190px] w-[120px]" src={sa} alt="" />
                <img className="lg:w-[110px] w-[80px]" src={us} alt="" />
                <img className="lg:w-[140px] w-[100px]" src={ngn} alt="" />
                <img className="lg:w-[140px] w-[100px]" src={ghana} alt="" />
                <img className="lg:w-[130px] w-[100px]" src={brazil} alt="" />
                <img className="lg:w-[140px] w-[100px]" src={greece} alt="" />
                <img className="lg:w-[130px] w-[100px]" src={china} alt="" />
                <img className="lg:w-[140px] w-[100px]" src={france2} alt="" />
                <img className="lg:w-[150px] w-[100px]" src={canada} alt="" />
                <img className="lg:w-[220px] w-[150px]" src={uk1} alt="" />
                <img className="lg:w-[150px] w-[100px]" src={mexico1} alt="" />
                <img className="lg:w-[124px] w-[80px]" src={india1} alt="" />
            </Marquee>

            <div className="mc:px-16 sh:px-8 px-3">
                <div className="relative">
                    {/* Background frame */}
                    <img
                        className="w-full max-w-[1440px] mx-auto mk:h-[800px] sd:h-[600px] h-[400px]"
                        src={frame}
                        alt=""
                    />

                    <div className="absolute top-1/2 -translate-y-1/2 w-full">
                        <div className="w-full grid grid-cols-[1fr_auto_1fr] items-center sm:gap-4 gap-2">
                            {/* Left slider */}
                            <div className="w-full">
                                <Slider ref={leftSlider} {...settingsLeft}>
                                    <div>
                                        <div className="flex items-center gap-2">
                                            <img className="sm:size-6 sk:size-4 size-3" src={flag6} alt="" />
                                            <p className="sm:text-xl sk:text-[17px] text-[13px] md:text-2xl lg:text-3xl font-semibold">Nigeria</p>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="flex items-center gap-2">
                                            <img className="sm:size-6 sk:size-4 size-3" src={flag2} alt="" />
                                            <p className="sm:text-xl sk:text-[17px] text-[13px] md:text-2xl lg:text-3xl font-semibold">USA</p>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="flex items-center gap-2">
                                            <img className="sm:size-6 sk:size-4 size-3" src={flag5} alt="" />
                                            <p className="sm:text-xl sk:text-[17px] text-[13px] md:text-2xl lg:text-3xl font-semibold">China</p>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="flex items-center gap-2">
                                            <img className="sm:size-6 sk:size-4 size-3" src={flag7} alt="" />
                                            <p className="sm:text-xl sk:text-[17px] text-[13px] md:text-2xl lg:text-3xl font-semibold">
                                                United Kingdom
                                            </p>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="flex items-center gap-2">
                                            <img className="sm:size-6 sk:size-4 size-3" src={flag3} alt="" />
                                            <p className="sm:text-xl sk:text-[17px] text-[13px] md:text-2xl lg:text-3xl font-semibold">
                                                South Africa
                                            </p>
                                        </div>
                                    </div>
                                </Slider>
                            </div>

                            {/* Arrows */}
                            <div className="flex items-center justify-center sh:text-2xl text-lg md:gap-4 gap-2 text-black/60">
                                <FaArrowRight />
                                <FaArrowRight />
                                <FaArrowRight />
                            </div>

                            {/* Right slider */}
                            <div className="w-full">
                                <Slider ref={rightSlider} {...settingsRight}>
                                    <div>
                                        <div className="flex items-center gap-2 justify-end">
                                            <img className="sm:size-6 sk:size-4 size-3" src={flag7} alt="" />
                                            <p className="sm:text-xl sk:text-[17px] text-[13px] md:text-2xl lg:text-3xl font-semibold">
                                                United Kingdom
                                            </p>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="flex items-center gap-2 justify-end">
                                            <img className="sm:size-6 sk:size-4 size-3" src={flag1} alt="" />
                                            <p className="sm:text-xl sk:text-[17px] text-[13px] md:text-2xl lg:text-3xl font-semibold">France</p>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="flex items-center gap-2 justify-end">
                                            <img className="sm:size-6 sk:size-4 size-3" src={flag4} alt="" />
                                            <p className="sm:text-xl sk:text-[17px] text-[13px] md:text-2xl lg:text-3xl font-semibold">Canada</p>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="flex items-center gap-2 justify-end">
                                            <img className="sm:size-6 sk:size-4 size-3" src={flag6} alt="" />
                                            <p className="sm:text-xl sk:text-[17px] text-[13px] md:text-2xl lg:text-3xl font-semibold">Nigeria</p>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="flex items-center gap-2 justify-end">
                                            <img className="sm:size-6 sk:size-4 size-3" src={flag2} alt="" />
                                            <p className="sm:text-xl sk:text-[17px] text-[13px] md:text-2xl lg:text-3xl font-semibold">USA</p>
                                        </div>
                                    </div>
                                </Slider>
                            </div>
                        </div>

                        {/* Subtitle */}
                        <p className="2xl:text-3xl md:text-2xl text-[20px] mx-auto mt-10 text-[#525154] text-center max-w-3xl">
                            <span className="font-bold text-black">Send money</span> around the world
                            in <br /> no time,{" "}
                            <span className="font-bold text-black">
                                receive money easily <br />
                            </span>{" "}
                            and shop without borders, all <br /> using{" "}
                            <span className="font-bold text-black">stablecoins</span> on <br /> a safe
                            platform.
                        </p>
                    </div>
                </div>
            </div>

            <div className="sm:p-3 p-2 bg-gradient-to-tr flex items-center sm:gap-6 gap-2 text-lg 3xl:text-2xl from-[#531CB3] via-[#4B137C] to-[#601377] text-white">
                {/* Left stars */}
                <div className="flex items-center gap-4 shrink-0">
                    <img className="3xl:w-7 sm:w-5 w-3" src={stars} alt="" />
                    <img className="3xl:w-7 sm:w-5 w-3" src={stars} alt="" />
                    <img className="3xl:w-7 sm:w-5 w-3 sm:block hidden" src={stars} alt="" />
                </div>

                {/* Marquee text */}
                <div className="overflow-hidden whitespace-nowrap">
                    <div className="flex-1">
                        <Marquee speed={1.3}>
                            {messages.map((m, i) => (
                                <div key={i} className="inline-flex justify-between items-center gap-12 px-4 min-w-max">
                                    <p>{m}</p>
                                    <span className="w-[40px] bg-[#E6E4EB] h-1 rounded-full" />
                                </div>
                            ))}
                        </Marquee>
                    </div>
                </div>

                {/* Right stars */}
                <div className="flex items-center gap-4 shrink-0">
                    <img className="3xl:w-7 sm:w-5 w-3" src={stars} alt="" />
                    <img className="3xl:w-7 sm:w-5 w-3" src={stars} alt="" />
                    <img className="3xl:w-7 sm:w-5 w-3 sm:block hidden" src={stars} alt="" />
                </div>
            </div>

            <div className='sm:px-10 px-5 sm:py-32 py-16 relative'>
                <p className='sm:text-4xl text-2xl text-center font-semibold'>How it all comes together</p>
                <div className='flex mk:flex-row flex-col items-start text-white text-lg mt-10 relative z-50'>
                    <div className='bg-[#531CB3] p-6 h-[250px] flex flex-col justify-between'>
                        <p className='text-2xl'>Open an account</p>
                        <p className='text-[#D2D0D6] lg:text-lg mk:text-base text-lg'>Verify your ID just once, and instantly get live USD & EUR account details in your Reccur app. No long waits—your account is ready to go in minutes.</p>
                    </div>
                    <div className='bg-[#271D2E] p-6 h-[290px] flex flex-col justify-between'>
                        <p className='text-2xl'>Receive money</p>
                        <p className='text-[#D2D0D6] lg:text-lg mk:text-base text-lg'>Share your account details with clients—whether they’re paying by wire or transfer. The money lands in USDC, so the value stays stable and secure.</p>
                    </div>
                    <div className='bg-gradient-to-tr from-[#2B0E5D] via-[#401a82] via-[#452084] to-[#D2D0D6] p-6 h-[330px] flex flex-col justify-between'>
                        <p className='text-2xl'>Move your money</p>
                        <p className='text-[#D2D0D6] lg:text-lg mk:text-base text-lg'>Withdraw funds to your local bank in Nigeria, send to teammates in Ghana, Kenya, South Africa, or across the globe—US, UK, India, Philippines, Canada. </p>
                    </div>
                </div>
                <div className='flex items-center mt-20 mk:justify-end gap-0'>
                    <img className='mk:w-[127px] w-[72px]' src={combine} alt="" />
                    <p className='text-[#525154]'>Open a bank account in 30+ countries.</p>
                </div>
            </div>

            <div className='bg-[#271D2E] text-[#E6E4EB] sm:pt-36 pt-10 pb-12 2xl:gap-32 gap-10 mc:grid flex flex-col grid-cols-5'>
                <div className='col-span-2 flex flex-col gap-5 lg:pl-36 sm:pl-16 pl-5 mc:pr-0 sm:pr-16 pr-5'>
                    <p className='lg:text-4xl mc:text-start text-center text-[27px]'>A better way to manage your money, across borders</p>
                    <p className='text-[#D2D0D6] text-base 3xl:text-lg mc:text-start text-center'>Forget the complexity of traditional banking and crypto transfers. With Reccur, you can send, spend, and hold money in a way that’s fast, secure, and global—without the usual headaches.</p>
                </div>
                <div className='col-span-3 flex flex-col gap-5 leading-relaxed mc:mt-0 mt-10 lg:pr-36 sm:pr-16 pr-5 mc:pl-0 sm:pl-16 pl-5'>
                    <div className='lg:pb-16 pb-12 flex flex-col gap-3 border-b border-[#FFFFFF3D]'>
                        <p className='lg:text-3xl text-[22px]'>Keep your name on the account</p>
                        <p className='text-[#D2D0D6] text-base 3xl:text-lg'>No more mysterious wallet addresses—clients trust real bank accounts, and that’s exactly what we provide. Your name stays on the account, making transactions feel real and personal.</p>
                    </div>
                    <div className='lg:pt-10 pt-5 lg:pb-16 pb-12 flex flex-col gap-3 border-b border-[#FFFFFF3D]'>
                        <p className='lg:text-3xl text-[22px]'>Stability built in</p>
                        <p className='text-[#D2D0D6] text-base 3xl:text-lg'>Every cent you earn is automatically stabilized as USDC. No more worrying about currency fluctuations or market chaos. It’s like having the power of the dollar, always, without lifting a finger.</p>
                    </div>
                    <div className='lg:pt-10 pt-5 lg:pb-16 pb-12 flex flex-col gap-3 border-b border-[#FFFFFF3D]'>
                        <p className='lg:text-3xl text-[22px]'>Cash when you need it</p>
                        <p className='text-[#D2D0D6] text-base 3xl:text-lg'>Instantly swap your USDC for NGN or hold onto it for future use. Whether you need cash now or want to keep it digital, Reccur lets you do it your way—without waiting.</p>
                    </div>
                    <div className='lg:pt-10 pt-5 lg:pb-16 pb-12 flex flex-col gap-3'>
                        <p className='lg:text-3xl text-[22px]'>Pay the continent, from one balance</p>
                        <p className='text-[#D2D0D6] text-base 3xl:text-lg'>Whether it’s a business partner in Ghana, a supplier in Kenya, or family in South Africa, you can send money across Africa—and beyond—with ease. And, yes, it’s fast—faster than any bank could ever dream.</p>
                    </div>
                </div>
            </div>
            <div className="bg-[#271D2E] pb-12">
                <Marquee speed={1.3}>
                    <img className="lg:w-[180px] w-[140px]" src={sa2} alt="" />
                    <img className="lg:w-[100px] w-[80px]" src={us2} alt="" />
                    <img className="lg:w-[140px] w-[100px]" src={ngn2} alt="" />
                    <img className="lg:w-[140px] w-[100px]" src={ghana2} alt="" />
                    <img className="lg:w-[130px] w-[100px]" src={brazil2} alt="" />
                    <img className="lg:w-[140px] w-[110px]" src={greece2} alt="" />
                    <img className="lg:w-[120px] w-[100px]" src={china2} alt="" />
                    <img className="lg:w-[140px] w-[110px]" src={canada2} alt="" />
                    <img className="lg:w-[140px] w-[110px]" src={mexico2} alt="" />
                    <img className="lg:w-[220px] w-[177px]" src={uk2} alt="" />
                    <img className="lg:w-[110px] w-[90px]" src={india2} alt="" />
                    <img className="lg:w-[134px] w-[105px]" src={france3} alt="" />
                </Marquee>
            </div>

            <FAQ2 />

            <Footer />

        </div>
    )
}
export default HomeRoot2